import { render } from "./BlockGallery.vue?vue&type=template&id=6dce4d6c"
import script from "./BlockGallery.vue?vue&type=script&lang=js"
export * from "./BlockGallery.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/BlockEditors/BlockGallery.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6dce4d6c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6dce4d6c', __exports__)) {
    console.log('reload')
    api.reload('6dce4d6c', __exports__)
  }
  
  module.hot.accept("./BlockGallery.vue?vue&type=template&id=6dce4d6c", () => {
    console.log('re-render')
    api.rerender('6dce4d6c', render)
  })

}


export default __exports__